<template>
    <div class="flex flex-col h-full rounded-[inherit]">
        <slot></slot>
    </div>
</template>
